import * as _ from 'lodash';
import { JssObserver, JssEventData } from './jss-observers';

export type JssEventType =
   'VALUE_CHANGED';

export type JssEffectCondition =
   'EXPECTED_VALUE';

export interface JssRule {
   effectType: string;     // valid effects: [HIDE]
   effectCondition: JssEffectCondition;
   emittingNodeName: string;
   data: any;              // Condition(EXPECTED_VALUE): value to set rule in effect
}

interface JssSubject {
   registerObserver(eventType: JssEventType, obs: JssObserver);
   unregisterObserver(eventType: JssEventType, obs: JssObserver);
   notifyObservers(eventType: JssEventType, eventData: JssEventData);
}

export class JssEventSubject implements JssSubject {

   private observers: { [key: string]: JssObserver[] } = {};

   constructor(
   ) {}

   // register
   public registerObserver(eventType: JssEventType, obs: JssObserver) {
      this.observersPerEventType(eventType).push(obs);
   }

   // unregister
   public unregisterObserver(eventType: JssEventType, obs: JssObserver) {
      const newObservers = _.remove(
         this.observersPerEventType(eventType), el => el === obs);
      this.observers[eventType] = newObservers;
   }

   // notify observer
   public notifyObservers(eventType: JssEventType, eventData: JssEventData) {
      this.observersPerEventType(eventType)
         .forEach(obs => obs.eventNotify(eventData));
   }

   // helper function
   private observersPerEventType(eventType: JssEventType): JssObserver[] {
      const observersPerType = this.observers[eventType];
      if (!observersPerType) {
         this.observers[eventType] = [];
      }
      return this.observers[eventType];
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-subject.ts